import React, { useEffect, useState } from "react";
import ReplyUserProfile from "./Reply";
import PostCard from "./PostCard";
import { Spinner } from "react-bootstrap";
import EmptyState from "../emptyState";
import Image from "next/image";
import styles from "../../styles/Home.module.css"

export default function ActivityCard(props) {
  const [isVisible, setIsVisible] = useState(false)
  const userPosts = props.userPosts?.sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
  );
  const user = props.user;
  const postsLeft = props.postsLeft;

  const toggleVisibility = () => {
    if (window.pageYOffset > 30) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  // Show button when page is scorlled upto given distance
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    window.addEventListener("scroll", toggleVisibility);
  }, []);

  return (
    <div className="w-100 d-flex flex-column">
      {isVisible && (
        <span
          href="#"
          className={styles.float}
          onClick={scrollToTop}
          style={{ cursor: "pointer", zIndex: "100" }}
        >
          <p className={styles.myfloat}>&#8593;</p>
        </span>
      )}
      {userPosts?.length > 0 ? (
        userPosts?.map((userPost, index) => (
          <div key={userPost._id} id={`activityCard` + index}>
            <div
            style={{marginTop: index !== 0 && '20px'}}
              className={
                (index < userPosts.length - 1 &&
                  " mds-border-muted-bottom border-bottom ") + " m-1 p-1"
              }
              key={userPost.createdAt}
            >
              {userPost.type === "posted" && (
                <p>
                  {user.fullName}
                  <span className="text-muted">
                    {" "}
                    {userPost.postId.postType === "seek" ? "seeked" : "shared"}
                  </span>
                </p>
              )}
              {userPost.type === "liked-post" && (
                <p>
                  {user.fullName}
                  <span className="text-muted"> liked a post</span>
                </p>
              )}
              {userPost.type === "liked-reply" && (
                <p>
                  {user.fullName}
                  <span className="text-muted"> liked a comment</span>
                </p>
              )}
              {userPost.type === "commented" && (
                <p>
                  {user.fullName}
                  <span className="text-muted"> commented</span>
                </p>
              )}
              <PostCard post={userPost.postId} user={userPost.postId.userId} />
              {userPost.replyId && (
                <div className="ps-5">
                <ReplyUserProfile
                  reply={userPost.replyId}
                  user={userPost.replyId.userId}
                />
                </div>
              )}
            </div>
          </div>
        ))
      ) : (
        <div className="w-100 h-100 d-flex flex-column justify-content-center align-items-center">
          {/* <Image width="400px" src={EmptyState} alt="" /> */}
          <EmptyState />
        </div>
      )}
      {postsLeft > 0 && (
        <div className="d-flex align-items-center justify-content-center my-2">
          <button
            disabled={props.loading}
            onClick={props.handleLoadMore}
            className="mds-fw-lg flex-grow-0 btn flex-fill min-w-10 mds-btn mds-fs-4 btn-lg mds-text-primary"
          >
            {props.loading ? <Spinner animation="border" size="md" /> : "Load More"} 
          </button>
        </div>
      )}
    </div>
  );
}
